var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfinite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "6px",
    viewBox: "0 0 15 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "path-infinity",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "infinity",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7857098,0 C10.1116108,0 8.30357255,1.51350586 7.5,2.27150391 C6.69642745,1.51350586 4.88838921,0 3.2142902,0 C1.20162347,0 0,1.12151367 0,3 C0,4.87848633 1.20162347,6 3.2142902,6 C4.88838921,6 6.69642745,4.48649414 7.5,3.72849609 C8.30357255,4.48649414 10.1116108,6 11.7857098,6 C13.7984079,6 15,4.87848633 15,3 C15,1.12151367 13.7983765,0 11.7857098,0 Z M3.21425881,5.00000977 C1.79246902,5.00000977 1.07138821,4.32700195 1.07138821,2.99999023 C1.07138821,1.67299805 1.79246902,0.999990234 3.21425881,0.999990234 C4.39284234,0.999990234 5.95710932,2.23948242 6.76498223,2.99999023 C5.95874157,3.76151367 4.39764495,5.00000977 3.21425881,5.00000977 Z M11.7857098,5.00000977 C10.6071263,5.00000977 9.0428593,3.76051758 8.23498638,2.99999023 C9.03855893,2.23901367 10.6023237,0.999990234 11.7857098,0.999990234 C13.2074996,0.999990234 13.9285804,1.67299805 13.9285804,2.99999023 C13.9285804,4.32700195 13.2074996,5.00000977 11.7857098,5.00000977 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinite);
export default __webpack_public_path__ + "static/media/infinite.3cdd7255239a90dd69b7ddcd2acc9687.svg";
export { ForwardRef as ReactComponent };